import { Tag } from 'antd';
import type { ColumnsType } from 'antd/es/table';
import type { ArticleRow } from '../../api/client';
import CoverThumb from './CoverThumb';
import StatusBadge from './StatusBadge';
import { fmtTaipei } from './status';

const muted = (v?: string | null) =>
  v ? <span className="text-gray-600">{v}</span> : <span className="text-gray-300">—</span>;

/** 文章/頁面列表表格欄位定義。 */
export function buildColumns(onEdit: (id: string) => void): ColumnsType<ArticleRow> {
  return [
    {
      title: '封面',
      dataIndex: 'coverUrl',
      width: 88,
      render: (u: string | null) => <CoverThumb url={u} />,
    },
    {
      title: '標題',
      dataIndex: 'title',
      minWidth: 360,
      render: (t: string, r) => (
        <button
          type="button"
          onClick={() => onEdit(r.id)}
          title={t}
          className="line-clamp-2 w-full cursor-pointer border-0 bg-transparent p-0 text-left text-[15px] font-medium leading-snug text-gray-800 transition-colors hover:text-[#dd7900]"
        >
          {t}
        </button>
      ),
    },
    {
      title: '類型',
      dataIndex: 'kind',
      width: 80,
      render: (k: string) =>
        k === 'page' ? <Tag color="purple">頁面</Tag> : <Tag color="blue">文章</Tag>,
    },
    { title: '分類', dataIndex: 'categoryNames', width: 120, render: muted },
    { title: '作者', dataIndex: 'authorName', width: 110, render: muted },
    {
      title: '狀態',
      dataIndex: 'status',
      width: 150,
      render: (s: string, r) => <StatusBadge status={s} scheduledAt={r.scheduledAt} />,
    },
    {
      title: '更新時間',
      dataIndex: 'updatedAt',
      width: 170,
      render: (t: number) => <span className="text-xs text-gray-400">{fmtTaipei(t)}</span>,
    },
  ];
}
